import { MenuItem } from "../types";
import React from "react";

function getBreadCrumbsFromPath(): MenuItem[] {
  const path = document.location.pathname;
  const pathParts = path.split("/").filter(part => part !== ""); // Убираем пустые элементы

  const breadcrumbs: MenuItem[] = [
    {
      url: "/",
      name: "Главная",
      active: false
    }
  ];

  if (pathParts.length === 0) {
    breadcrumbs[0].active = true;
    return breadcrumbs;
  }

  switch (pathParts[0]) {
    case "events":
      breadcrumbs.push({
        url: "/events/1",
        name: "События",
        active: pathParts.length === 1
      });
      if (pathParts.length === 3 && pathParts[1] === "detail") {
        breadcrumbs.push({
          url: `/events/detail/${pathParts[2]}`,
          name: `Событие № ${pathParts[2]}`,
          active: true
        });
      }
      break;

    case "tasks":
      breadcrumbs.push({
        url: "/tasks/1",
        name: "Задачи",
        active: pathParts.length === 1
      });
      if (pathParts.length === 3 && pathParts[1] === "detail") {
        breadcrumbs.push({
          url: `/tasks/detail/${pathParts[2]}`,
          name: `Задача № ${pathParts[2]}`,
          active: true
        });
      }
      break;

    case "clients":
      breadcrumbs.push({
        url: "/clients/1",
        name: "Клиенты",
        active: pathParts.length === 1
      });
      if (pathParts.length === 2 && pathParts[1] === "sources") {
        breadcrumbs.push({
          url: "/clients/sources",
          name: "Источники",
          active: true
        });
      } else if (pathParts.length === 2 && pathParts[1] === "detail") {
        breadcrumbs.push({
          url: `/client/${pathParts[2]}`,
          name: `Клиент № ${pathParts[2]}`,
          active: true
        });
      }
      break;

    case "analytics":
      breadcrumbs.push({
        url: "/analytics",
        name: "Аналитика",
        active: pathParts.length === 1
      });
      if (pathParts.length === 2) {
        const analyticsPages = {
          salesplan: "План продаж",
          salesfunnel: "Воронка продаж",
          grouprating: "Рейтинг групп",
          hirerating: "Рейтинг найма",
          eventfunnel: "Воронка событий",
          practicefunnel: "Воронка практик",
          peoplerating: "Рейтинг сотрудников",
          converse: "Конверсия источников"
        };
        if (analyticsPages[pathParts[1]]) {
          breadcrumbs.push({
            url: `/analytics/${pathParts[1]}`,
            name: analyticsPages[pathParts[1]],
            active: true
          });
        }
      }
      break;

    case "users":
      breadcrumbs.push({
        url: "/users/1",
        name: "Пользователи",
        active: pathParts.length === 1
      });
      if (pathParts.length === 2 && pathParts[1] === "invites") {
        breadcrumbs.push({
          url: "/users/invites",
          name: "Приглашения",
          active: true
        });
      }
      break;

    case "groups":
      breadcrumbs.push({
        url: "/groups/1",
        name: "Группы пользователей",
        active: true
      });
      break;

    case "roles":
      breadcrumbs.push({
        url: "/roles/1",
        name: "Настройки ролей",
        active: true
      });
      break;

    case "profile":
      breadcrumbs.push({
        url: "/profile",
        name: "Профиль",
        active: pathParts.length === 1
      });
      if (pathParts.length === 2 && pathParts[1] === "edit") {
        breadcrumbs.push({
          url: "/profile/edit",
          name: "Редактирование профиля",
          active: true
        });
      } else if (pathParts.length === 3 && pathParts[1] === "edit") {
        breadcrumbs.push({
          url: `/profile/edit/${pathParts[2]}`,
          name: `Редактирование профиля № ${pathParts[2]}`,
          active: true
        });
      } else if (pathParts.length === 2) {
        breadcrumbs.push({
          url: `/profile/${pathParts[1]}`,
          name: `Профиль № ${pathParts[1]}`,
          active: true
        });
      }
      break;

    default:
      breadcrumbs[0].active = true;
  }

  return breadcrumbs;
}

const Breadcrumbs = () => {
  return (
    <div className="breadCrumbs">
      <div className="flex">
        {getBreadCrumbsFromPath().map((item, index) => (
          <div className={`crumb${item.active ? " active" : ""}`} key={`${index}${item.name}bcrs`}>
            {index > 0 && <span>/</span>}
            <a href={item.url}>{item.name}</a>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Breadcrumbs;